import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {getCycleSpans, getCycleString} from 'effects/midi/tidal/parser.js';

const CycleAnalyzer = ({tidal, cycle, currentLeaves, immutable}) => { 
    let {spans, index} = getCycleSpans(cycle, currentLeaves, true);
    let className = immutable ? "immutable tidal-string" : "tidal-string";
    if (currentLeaves && currentLeaves.some(
        x => x.transpose !== null)) {
        className += " triggering";
    }
    return (
        <div className={className}>
          <span className="cycle-length">
            {tidal.cycleLength}
          </span>
          <div onClick={
              () => tidal.lockGroove(!immutable)}
               className={immutable ? "immutable dot" : "dot"}/>
          {spans.map(
              (s, i) => <span keys={i} className={i === index ? "str-part current" : "str-part"}>{s}</span>)}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      immutable: props.tidal.cycleParameter.immutable,
      cycle: props.tidal.cycle,
      currentLeaves: props.tidal.currentLeaves
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CycleAnalyzer);

